<template>
    <div class="table-responsive" style="overflow-x: auto; max-width: 100%;">
      <div class="card">
        <h5 class="card-header">Search Filter</h5>
        <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
          <div class="col-md-6 col-sm-12">
            <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
          </div>
          <div class="col-md-6 col-sm-12">
            <select class="form-control" v-model="type">
              <option :value="null" disabled>Select Type</option>
              <option v-for="type in types" :key="type.id" :value="type.id">{{ type.name }}</option>
            </select>
          </div>
        </div>
        <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
          <div class="col-lg-4 mb-1 col-sm-12">
            <button type="button" class="btn btn-primary"  @click="onSubmitFilters" >Search</button>
            <button type="button" class="ml-1 btn btn-danger " @click="clear" >Clear</button>
          </div>
        </div>

      </div>
      <CommonTableCustomRow
          url="v1/merchant-schema-acquiring"
          :tableHeaderValues="channelHeaders"
          :useCustomRows="true"
          :actions="channelActions"
          :mutedData="channelMutedData"
          :storageKey="storageKey"
          :show-per-page="true"
          :filteredData="channelFilteredData"
          @pageChange="resetChannelAccordions"
      >
        <template #row="{ row, index, count }">
          <!-- Channel Row -->
          <tr :key="`channel-${row.id || index}`">
            <td>{{ count + index + 1 }}</td>
            <td>{{ row.name }}</td>
            <td>{{ row.code }}</td>
            <td v-html="alterType(row.type)"></td>
            <td>
              <span v-if="row.status == 1" class="badge badge-light-success">Active</span>
              <span v-else class="badge badge-light-danger">Inactive</span>
            </td>
            <td>
              <button
                  @click="toggleChannelAccordion(index)"
                  class="btn btn-sm badge btn-dark"
              >
                {{ expandedChannels.includes(index) ? '[-]' : '[+]' }}
                Groups ({{ row.groups?.length || 0 }})
              </button>
            </td>
          </tr>

          <!-- Groups Accordion -->
          <tr v-if="expandedChannels.includes(index)" :key="`channel-expanded-${row.id || index}`">
            <td :colspan="5" class="">
              <div class="pl-4 pr-4 pt-2 pb-2">
                <table class="table border-dark  badge-glow">
                  <thead class="thead-dark">
                  <tr>
                    <th>S.No</th>
                    <th style="min-width: 150px !important;">Group Name</th>
                    <th>Code</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(group, groupIndex) in row.groups">
                    <tr :key="`group-${group.id || groupIndex}`">
                      <td>{{ groupIndex + 1 }}</td>
                      <td>{{ group.name }}</td>
                      <td>{{ group.code }}</td>
                      <td>
                        <span v-if="group.status == 1" class="badge badge-light-success">Active</span>
                        <span v-else class="badge badge-light-danger">Inactive</span>
                      </td>
                      <td>
                        <button
                            @click="toggleGroupAccordion(index, groupIndex)"
                            class="btn btn-sm badge btn-warning"
                        >
                          {{ expandedGroups[`${index}-${groupIndex}`] ? '[-]' : '[+]' }}
                          Schemas ({{ group.schemas?.length || 0 }})
                        </button>
                      </td>
                    </tr>

                    <!-- Schemas Accordion -->
                    <tr v-if="expandedGroups[`${index}-${groupIndex}`]" :key="`group-expanded-${group.id || groupIndex}`">
                      <td :colspan="5" class="">
                        <div class="pl-5 pr-4 pt-2 pb-2">
                          <table class="table table-sm border-dark ">
                            <thead class="thead-dark">
                            <tr>
                              <th>S.No</th>
                              <th style="min-width: 150px !important;">Schema Name</th>
                              <th>Code</th>
                              <th>Currency</th>
                              <th>Status</th>
                              <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for="(schema, schemaIndex) in group.schemas">
                              <tr :key="`schema-${schema.id || schemaIndex}`">
                                <td>{{ schemaIndex + 1 }}</td>
                                <td>{{ schema.name }}</td>
                                <td>{{ schema.code }}</td>
                                <td>{{ schema.currency?.code || '-' }}</td>
                                <td>
                                  <span v-if="schema.status == 1" class="badge badge-light-success">Active</span>
                                  <span v-else class="badge badge-light-danger">Inactive</span>
                                </td>
                                <td>
                                  <button
                                      @click="toggleSchemaAccordion(index, groupIndex, schemaIndex)"
                                      class="btn btn-sm badge btn-info"
                                  >
                                    {{ expandedSchemas[`${index}-${groupIndex}-${schemaIndex}`] ? '[-]' : '[+]' }}
                                    Acquirings ({{ schema.schema_aquirings?.length || 0 }})
                                  </button>
                                </td>
                              </tr>

                              <!-- Acquirings Accordion -->
                              <tr v-if="expandedSchemas[`${index}-${groupIndex}-${schemaIndex}`]" :key="`schema-expanded-${schema.id || schemaIndex}`">
                                <td :colspan="6" class="">
                                  <div class="pl-5 pr-4 pt-2 pb-2">
                                    <table class="table table-sm border-dark ">
                                      <thead class="thead-dark">
                                      <tr>
                                        <th>S.No</th>
                                        <th style="min-width: 150px !important;">Acquiring Name</th>
                                        <th>Code</th>
                                        <th>Status</th>
                                        <th style="min-width: 215px !important;">Schema Acquiring Status</th>
                                        <th>Actions</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      <template v-for="(acquiring, acquiringIndex) in schema.schema_aquirings">
                                        <tr :key="`acquiring-${acquiring.id || acquiringIndex}`">
                                          <td>{{ acquiringIndex + 1 }}</td>
                                          <td>{{ acquiring.aquiring?.name || '-' }}</td>
                                          <td>{{ acquiring.aquiring?.code || '-' }}</td>
                                          <td>
                                            <span v-if="acquiring.aquiring?.status == 1" class="badge badge-light-success">Active</span>
                                            <span v-else class="badge badge-light-danger">Inactive</span>
                                          </td>
                                          <td class="text-center">
                                            <span v-if="acquiring.status == 1" class="badge badge-light-success">Active</span>
                                            <span v-else class="badge badge-light-danger">Inactive</span>
                                          </td>
                                          <td>
                                            <button
                                                @click="toggleAcquiringAccordion(index, groupIndex, schemaIndex, acquiringIndex)"
                                                class="btn btn-sm badge btn-danger"
                                            >
                                              {{ expandedAcquirings[`${index}-${groupIndex}-${schemaIndex}-${acquiringIndex}`] ? '[-]' : '[+]' }}
                                              Transaction Types ({{ acquiring.aquiring?.transaction_types?.length || 0 }})
                                            </button>
                                          </td>
                                        </tr>

                                        <!-- Transaction Types Accordion -->
                                        <tr v-if="expandedAcquirings[`${index}-${groupIndex}-${schemaIndex}-${acquiringIndex}`]" :key="`acquiring-expanded-${acquiring.id || acquiringIndex}`">
                                          <td :colspan="6" class="">
                                            <div class="pl-5 pr-4 pt-2 pb-2">
                                              <table class="table table-sm border-dark ">
                                                <thead class="thead-dark">
                                                <tr>
                                                  <th>S.No</th>
                                                  <th style="min-width: 150px !important;">Transaction Type</th>
                                                  <th>Status</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(transactionType, ttIndex) in acquiring.aquiring?.transaction_types" :key="`tt-${transactionType.id || ttIndex}`">
                                                  <td>{{ ttIndex + 1 }}</td>
                                                  <td>{{ transactionType.name }}</td>
                                                  <td>
                                                    <span v-if="transactionType.pivot?.status == 1" class="badge badge-light-success">Active</span>
                                                    <span v-else class="badge badge-light-danger">Inactive</span>
                                                  </td>
                                                </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </td>
                                        </tr>
                                      </template>
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            </template>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </template>
      </CommonTableCustomRow>
    </div>
</template>

<script>

import CommonTableCustomRow from "@/components/dashboard/common/CommonTableCustomRow.vue";

export default {
  components: {CommonTableCustomRow},
  props:['filter'],
  mounted() {
    localStorage.setItem("url", "v1/merchant-schema-acquiring");
    this.checkDataInStore('v1/merchant-schema-acquiring')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }

    this.channelFilteredData = this.filter
  },
  data() {
    return {
      url: "v1/merchant-schema-acquiring",
      storageKey: "merchantInnerChannelList",
      channelHeaders: [
        { title: 'S.No', valueKey: 'index' },
        { title: 'Channel Name', valueKey: 'name' },
        { title: 'Code', valueKey: 'code' },
        {
          title: "Type",
          valueKey: "type",
        },
        { title: 'Status', valueKey: 'status' },
        { title: 'Actions' }
      ],
      expandedChannels: [],
      expandedGroups: {},
      expandedSchemas: {},
      expandedAcquirings: {},
      channelActions: [],
      channelMutedData: [],
      channelFilteredData: { },
      search: "",
      type: null,
      types: [
        {
          id: 1,
          name: "Eccomerce"
        },
        {
          id: 2,
          name: "POS"
        },
        {
          id: 3,
          name: "ATM"
        }
      ],
    };
  },
  methods: {
    alterType(value) {
      let label = "";
      if(value){
        if (value.toString() == 1) {
          label = 'Eccomerce'
        }else if (value.toString() == 2) {
          label = 'POS'
        }else if (value.toString() == 3) {
          label = 'ATM'
        }
      }

      return `<span class="badge badge-light-primary badge-sm">${label}</span>`;
    },
    onSubmitFilters() {

      let filterData = {...this.filter}


      if(this.search != ''){
        filterData.search = this.search
      }

      if(this.type != null){
        filterData.type = this.type
      }

      this.channelFilteredData ={...filterData}

    },
    clear(){
      this.search = ''
      this.type = null
      this.channelFilteredData ={...this.filter}
    },
    toggleChannelAccordion(index) {
      if (this.expandedChannels.includes(index)) {
        this.expandedChannels = this.expandedChannels.filter(i => i !== index);
      } else {
        this.expandedChannels.push(index);
      }
    },

    toggleGroupAccordion(channelIndex, groupIndex) {
      const key = `${channelIndex}-${groupIndex}`;
      this.expandedGroups = {
        ...this.expandedGroups,
        [key]: !this.expandedGroups[key]
      };
    },

    toggleSchemaAccordion(channelIndex, groupIndex, schemaIndex) {
      const key = `${channelIndex}-${groupIndex}-${schemaIndex}`;
      this.expandedSchemas = {
        ...this.expandedSchemas,
        [key]: !this.expandedSchemas[key]
      };
    },

    toggleAcquiringAccordion(channelIndex, groupIndex, schemaIndex, acquiringIndex) {
      const key = `${channelIndex}-${groupIndex}-${schemaIndex}-${acquiringIndex}`;
      this.expandedAcquirings = {
        ...this.expandedAcquirings,
        [key]: !this.expandedAcquirings[key]
      };
    },

    resetChannelAccordions() {
      this.expandedChannels = [];
      this.expandedGroups = {};
      this.expandedSchemas = {};
      this.expandedAcquirings = {};
    },
  }
};
</script>
